<template>
  <ul class="flex flex-wrap justify-center gap-4 lg:justify-start">
    <li v-for="(link, idx) in socialsFooterMenu" :key="idx">
      <a
        :href="link.url"
        :aria-label="link?.currentTranslation?.title"
        target="_blank"
        class="hover:opacity-80"
      >
        <UiLazyImg
          :src="link?.icon || ''"
          :alt="link?.currentTranslation?.title"
          class="size-4 object-contain"
        />
      </a>
    </li>
  </ul>
</template>

<script setup lang="ts">
const { socialsMenu } = useGeneralStore();

const socialsFooterMenu = computed(() => {
  return toTree(socialsMenu);
});
</script>
